import ContactAdd from '../components/ContactAdd.vue';
import ContactEdit from '../components/ContactEdit.vue';
import ContactList from '../components/ContactList.vue';
import BulkContactEdit from '../components/BulkContactEdit.vue';

export default [
  {
    path: '',
    redirect: 'list',
    role: ['User']
  },
  {
    path: 'list',
    component: ContactList,
    meta: {
      title: 'Contact List',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'Contacts'
        }
      ]
    }
  },
  {
    path: 'add',
    component: ContactAdd,
    meta: {
      title: 'Add Contact',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'Contacts'
        },
        {
          path: 'add',
          title: 'Add Contact'
        }
      ]
    }
  },
  {
    path: 'bulk-edit',
    component: BulkContactEdit,
    meta: {
      title: 'Bulk Edit Contacts',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'Contacts'
        },
        {
          path: 'bulk-edit',
          title: 'Bulk Edit Contacts'
        }
      ]
    }
  },
  {
    path: ':contact',
    component: ContactEdit,
    meta: {
      title: 'Edit Contact',
      role: ['User'],
      breadcrumb: [
        {
          path: '/home',
          title: 'Home'
        },
        {
          path: '/notification',
          title: 'Notifications'
        },
        {
          path: 'list',
          title: 'Contacts'
        },
        {
          path: '',
          title: 'Edit Contact'
        }
      ]
    }
  }
];
